export const SERVICES = [
  {
    key: "inspections",
    title: "Property Inspections",
    short: "Occupancy, exterior, interior, and hazard photo documentation.",
    long: "Timestamped, GPS-verified photos with defensible chain-of-custody metadata. Delivered as auditable PDF packets.",
    image: "https://images.pexels.com/photos/8293678/pexels-photo-8293678.jpeg",
  },
  {
    key: "lawn",
    title: "Lawn Maintenance",
    short: "Recurring grass cuts, edging, and seasonal cleanup at scale.",
    long: "Route-optimized crews across the coverage footprint. Before/after documentation on every visit.",
    image: "https://images.pexels.com/photos/5163420/pexels-photo-5163420.jpeg",
  },
  {
    key: "winterization",
    title: "Winterization",
    short: "Freeze-protection for water systems on vacant assets.",
    long: "Drain-downs, antifreeze application, appliance disconnection, and re-winterization inspections.",
    image: "https://images.pexels.com/photos/164558/pexels-photo-164558.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "debris",
    title: "Debris Removal",
    short: "Interior/exterior debris hauling and lawful disposal.",
    long: "Yard, cubic-yard, and cleanout metrics captured with photo evidence. Landfill receipts available on request.",
    image: "https://images.pexels.com/photos/8293678/pexels-photo-8293678.jpeg",
  },
  {
    key: "locks",
    title: "Lock Changes / Rekeys",
    short: "Secure re-keying with knob-lock and deadbolt combinations.",
    long: "Standardized institutional key codes on request. All entry points documented with photos.",
    image: "https://images.pexels.com/photos/164558/pexels-photo-164558.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "reo",
    title: "REO Cleanouts",
    short: "Full personal property removal and initial services.",
    long: "Trash-out, sanitation, mowing, and rekey packages priced per square foot for portfolio-scale operations.",
    image: "https://images.pexels.com/photos/8961008/pexels-photo-8961008.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "boarding",
    title: "Boarding &amp; Securing",
    short: "HUD-spec boarding for broken windows and forced entries.",
    long: "Half-inch plywood, painted trim, and clear-boarding options. Every opening photographed on completion.",
    image: "https://images.pexels.com/photos/164558/pexels-photo-164558.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title.replace(/&amp;/g, "&"));

export const COVERAGE_REGIONS = [
  { code: "NJ", name: "New Jersey", counties: 21, cities: "Newark · Jersey City · Paterson · Trenton · Camden · Atlantic City" },
  { code: "PA", name: "Pennsylvania", counties: 67, cities: "Philadelphia · Pittsburgh · Allentown · Harrisburg · Erie · Scranton" },
];

export const CASE_STUDIES = [
  {
    client: "Regional Bank Portfolio",
    metric: "1,240",
    label: "Assets serviced quarterly",
    quote:
      "Turnaround on P&P inspections dropped from 96h to 42h. Their reporting maps directly to our compliance workflow.",
    role: "VP, Default Servicing",
  },
  {
    client: "GSE-Approved Servicer",
    metric: "99.4%",
    label: "First-pass acceptance rate",
    quote:
      "Photo documentation quality set a new benchmark for our vendor network. Zero re-inspection requests last quarter.",
    role: "Director, REO Operations",
  },
  {
    client: "National Asset Manager",
    metric: "24h",
    label: "Emergency response SLA",
    quote:
      "Storm-damage boarding coordinated across the entire coverage area in under a day. Their portal made intake painless.",
    role: "Field Operations Lead",
  },
];
